import React, { Component } from 'react';

import { t } from '../locales/i18n';
export class SmallCarrierDisclaimer extends Component {
    
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="disclaimer">
                <p>{t('smallCarrierDisclaimer.note')}</p>
                <p className='bottom-10' dangerouslySetInnerHTML={{ __html: t('smallCarrierDisclaimer.contact') }} />
            </div>
        );
    }
}
